export default class NewSet {
  id: number;

  constructor (id: number){
    this.id = id;
  }
}
